// Generated by scripts/build-ui-icons.mjs.
export { Lightbulb as default } from "../ui/glyphs-5";
